import { pathOr, takeLast } from 'ramda';
import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { bigWinsRefreshRateSelector } from '../../redux/reducers/app/configuration';

export const getMockData = () => {
  return import('./mockData.json');
};

const MOCK_WINNER_POSITIONS = {
  current: 7,
  history: 1,
};

export const getMockHallOfFameData = (current, userNumber) => {
  return getMockData().then((res) => {
    const currentPathOption = current ? 'current' : 'history';
    const result = pathOr([], ['hall-of-fame', currentPathOption], res);

    if (userNumber) {
      result[MOCK_WINNER_POSITIONS[currentPathOption]] = {
        ...result[MOCK_WINNER_POSITIONS[currentPathOption]],
        player: userNumber,
      };
    }
    return result;
  });
};

const MOCK_BIG_WINS_QUERY_KEY = 'mock-big-wins';
const useQueryMockData = (enabled) => {
  const fetch = () =>
    getMockData().then((res) => res?.mockedBigWins?.data || []);
  return useQuery([MOCK_BIG_WINS_QUERY_KEY], fetch, {
    enabled,
  });
};
export const useQueryMockBigWinsData = (enabled) => {
  const [data, setData] = useState([]);
  const refreshRate = useSelector(bigWinsRefreshRateSelector);
  const { isLoading, data: queryData } = useQueryMockData(enabled);

  useEffect(() => {
    if (enabled && queryData?.length) {
      let counter = 0;
      const iv = setInterval(() => {
        try {
          setData((state) => [
            queryData[counter++ % queryData?.length],
            ...state,
          ]);
        } catch {
          setData([]);
        }
      }, refreshRate);
      return () => {
        clearInterval(iv);
      };
    }
  }, [enabled, queryData, refreshRate]);

  useEffect(() => {
    // initial setup of first 3 wins
    if (queryData?.length) {
      setData(takeLast(3, queryData));
    }
  }, [queryData]);
  return {
    isLoading,
    data,
  };
};
